export enum PrintTemplateType {
  Reservation = 'reservation',
  Ticket = 'ticket',
  GiftCard = 'gift_card',
}

export interface PrintTemplateOption {
  key: string;
  name: string;
}
